import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { getOrderedOrders, getOrders, getOrdersPageInfo, LoadMoreOrders } from 'src/app/shop';
import { Order, OrderLineItem } from 'src/app/shop/models/order.model';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { Breadcrumb } from 'src/app/core/models/breadcrumb.model';
import { SetTitle } from 'src/app/store';
@Component({
    selector: 'app-account-order-overview',
    templateUrl: './account-order-overview.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AccountOrderOverviewComponent implements OnInit {
  private lang = inject(LanguageService);
  private router = inject(Router);
  private store = inject(Store);
  private dict = new FromDictionaryPipe(this.lang);

  orders$ = this.store.selectSignal(getOrderedOrders);
  pages$ = this.store.selectSignal(getOrdersPageInfo);

  breadcrumbs: Breadcrumb[] = [];

  prefix = 'order-overzicht';

  constructor() {}

  ngOnInit(): void {
    this.store.dispatch(
      SetTitle({
        title: `${this.dict.transform(this.prefix + '-titel')} - ${this.dict.transform('meta-titel-suffix')}`,
      })
    );

    this.breadcrumbs = [
      {
        label: this.dict.transform(`account-menu-titel`),
        routerLink: ['/account'],
      },
      {
        label: this.dict.transform(`account-orders-menu-titel`),
        routerLink: ['/account/orders'],
      },
    ];
  }

  navigate(id: string) {
    this.router.navigate(['/account/orders/' + id]);
  }

  loadMore() {
    this.store.dispatch(LoadMoreOrders());
  }
}
